import { render, staticRenderFns } from "./m_translate.vue?vue&type=template&id=ed9a7f40&scoped=true&"
import script from "./m_translate.vue?vue&type=script&lang=js&"
export * from "./m_translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9a7f40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9a7f40')) {
      api.createRecord('ed9a7f40', component.options)
    } else {
      api.reload('ed9a7f40', component.options)
    }
    module.hot.accept("./m_translate.vue?vue&type=template&id=ed9a7f40&scoped=true&", function () {
      api.rerender('ed9a7f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/tabs/m_translate.vue"
export default component.exports